import { render, staticRenderFns } from "./ToReceiveTable.vue?vue&type=template&id=1f685515&scoped=true"
import script from "./ToReceiveTable.vue?vue&type=script&lang=js"
export * from "./ToReceiveTable.vue?vue&type=script&lang=js"
import style0 from "./ToReceiveTable.vue?vue&type=style&index=0&id=1f685515&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f685515",
  null
  
)

export default component.exports